import React from "react";
import { motion } from "framer-motion";
import { Plus, Lightbulb, Code, Rocket, Share2 } from "lucide-react";

export const Process = () => {
  const steps = [
    { id: 1, icon: <Plus size={60} />, title: "Data Gathering", desc: "Start with your project" },
    { id: 2, icon: <Lightbulb size={60} />, title: "Planning", desc: "Map out your journey" },
    { id: 3, icon: <Code size={60} />, title: "Development", desc: "Build your solution" },
    { id: 4, icon: <Rocket size={60} />, title: "Testing", desc: "Ensure quality delivery" },
    { id: 5, icon: <Share2 size={60} />, title: "Deployment", desc: "Launch to production" },
  ];

  return (
    <section
      style={{
        background: "linear-gradient(180deg, #f8f9fb 0%, #ffffff 100%)",
        color: "#000",
        padding: "8rem 2rem",
        textAlign: "center",
      }}
    >
      {/* Header */}
      <div style={{ maxWidth: "900px", margin: "0 auto 5rem" }}>
        <h2
          style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "1.5rem",
            letterSpacing: "-0.5px",
          }}
        >
          Our Project Process
        </h2>
        <p
          className="mb-4 mx-auto"
          style={{
            maxWidth: "540px",
            fontSize: "1.5rem",
            color: "#333",
            lineHeight: 1.8,
          }}
        >
          Our approach is simple: listen deeply, design smart, build fast.  
          Here’s how we bring your vision to life with clarity and care.
        </p>
      </div>

      {/* Steps */}
      <div className="process-grid">
        {steps.map((step, index) => (
          <motion.div
            key={step.id}
            className="process-card"
            initial={{ opacity: 0, y: 50 }}       // start hidden & moved down
            whileInView={{ opacity: 1, y: 0 }}    // animate when in view
            viewport={{ once: true, amount: 0.2 }} // trigger once per card
            transition={{
              duration: 0.6,
              delay: index * 0.2,                 // staggered animation
              ease: "easeOut",
            }}
          >
            <div className="process-icon">{step.icon}</div>
            <h3>
              {step.id}. {step.title}
            </h3>
            <p>{step.desc}</p>
          </motion.div>
        ))}
      </div>

      <style>
        {`
          .process-grid {
            display: grid;
            gap: 2.5rem;
            max-width: 1300px;
            margin: 0 auto;
            justify-content: center;
          }

          @media (max-width: 600px) {
            .process-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (min-width: 601px) and (max-width: 992px) {
            .process-grid {
              grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            }
          }

          @media (min-width: 993px) {
            .process-grid {
              grid-template-columns: repeat(5, 1fr);
            }
          }

          .process-card {
            background: rgba(255, 255, 255, 0.65);
            border: 1px solid rgba(0,0,0,0.08);
            border-radius: 24px;
            padding: 3.5rem 2rem;
            box-shadow: 0 12px 40px rgba(0,0,0,0.08), inset 0 1px 1px rgba(255,255,255,0.5);
            backdrop-filter: blur(18px);
            transition: all 0.3s ease;
          }

          .process-card:hover {
            transform: translateY(-10px) scale(1.02);
            box-shadow: 0 20px 50px rgba(0,0,0,0.12);
          }

          .process-icon {
            color: #000;
            margin-bottom: 2rem;
          }

          .process-card h3 {
            font-size: 1.6rem;
            font-weight: 800;
            margin-bottom: 0.8rem;
          }

          .process-card p {
            font-size: 1.15rem;
            color: #555;
          }

          .process-card:hover .process-icon {
            color: #007bff;
            transition: color 0.3s ease;
          }
        `}
      </style>
    </section>
  );
};

export default Process;
